import { useThemeSync } from "@/hooks/layout/useThemeSync";
import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { effectiveTheme } = useThemeSync()

  return (
    <Sonner
      theme={effectiveTheme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster }
